import _ from 'lodash'
import axios from '@/plugins/axios'
import {getProperties} from '@/store/form/componentDefaults.js'
import { FormComponent } from '@/store/form/component.js'

export default class ProcessService {
  processDefinition
  formService
  processVue = null

  constructor (processDefinition, formService, appProcessModel) {
    this.processDefinition = processDefinition
    this.formService = formService
  }
  getConections (id) {
    return this.processDefinition.process.getConectionsByNodeId(id)
  }
  // 保存流转通知
  saveNotice (object) {
    let connection = this.processDefinition.process.connections.find(m => m.id === object.connectionId)
    if (connection) {
      connection.notice = object.notice
    }
  }
  saveConnectionTimng (object) {
    let connection = this.processDefinition.process.connections.find(m => m.id === object.connectionId)
    if (connection) {
      connection.timing = object.timing
    }
  }
  saveConnections (object) {
    // 先删除当前节点的全部的线,再将当前节点修改过或者添加的线添加进去
    let connectionsWithoutCurrentNodeId = this.processDefinition.process.connections.filter(m => m.sourceNodeId !== object.currentNodeId)
    object.connections.forEach(el => {
      connectionsWithoutCurrentNodeId.push(el)
    })
    this.processDefinition.process.connections = connectionsWithoutCurrentNodeId
  }
  async addNode (node) {
    let newNode = this.processDefinition.process.addNode(node)
    let component = getProperties('rc-form')
    component.defaults.archive.enable = false
    component.defaults.name = newNode.name
    component.defaults.id = newNode.formId
    if (!component.defaults.pinyinName || !component.defaults.pinyinFirstChar) {
      let pingyin = await this.formService.getPinyinByHanzi(component.defaults.name)
      _.merge(component.defaults, {...pingyin})
    }
    this.formService.component.children.push(FormComponent.create(component.defaults))
  }
  removeNode (nodeId) {
    let node = this.processDefinition.process.removeNode(nodeId)
    let component = this.formService.component.children.find(n => n.id === node.formId)
    this.formService.removeComponent(component)
  }
  saveSelectPerson (param) {
    let node = this.processDefinition.process.nodes.find(m => m.id === param.nodeId)
    node.candidates = param.candidates
    node.candidateShowNode = param.candidateShowNode
    node.candidateRequired = param.candidateRequired
  }

  updateCandidateType (param) {
    let node = this.processDefinition.process.nodes.find(m => m.id === param.id)
    if (param.type === 'user') {
      // 如果是自定义, 则写入展示节点的信息, 否则, 取消展示节点的信息
      let parentNodes = this.processDefinition.process.getParentNode(node.id)
      node.candidateShowNode = parentNodes[0].sourceNodeId
    } else {
      node.candidateShowNode = ''
    }
    node.candidates = [{'targetId': '', 'name': '', 'type': param.type, defaultValue: false}]
    node.candidateShowNode = ''
  }

  async updateNodeName (param) {
    let node = this.processDefinition.process.nodes.find(m => m.id === param.id)
    let component = this.formService.component.children.find(m => m.id === node.formId)
    if (component) {
      // 如果单个节点独自归档的话, 该方法不能修改归档表的名字
      component.name = param.name
    }
    let pingyin = await this.formService.getPinyinByHanzi(param.name)
    _.merge(param, {...pingyin})
    node.name = param.name
  }

  updateNodeAction (param) {
    let node = this.processDefinition.process.nodes.find(m => m.id === param.nodeId)
    if (node) {
      let action = node.actions.find(m => m.id === param.id)
      _.merge(action, param)
    }
  }

  // 防止其他地方调用了该方法，加上默认值
  addAction (nodeId, action = {name: '未命名'}) {
    let node = this.processDefinition.process.nodes.find(m => m.id === nodeId)
    node.addButton(action)
  }

  removeNodeAction (param) {
    let node = this.processDefinition.process.nodes.find(m => m.id === param.nodeId)
    let index = node.actions.findIndex(m => m.id === param.actionId)
    if (index > -1) {
      node.actions.splice(index, 1)
    }
  }

  updatePosition (node) {
    this.processDefinition.process.updatePosition(node)
  }
  changeDefinitionName (value) {
    this.processDefinition.name = value
  }

  publish () {
    let definition = _.cloneDeep(this.processDefinition)
    let formService = this.formService.build()
    definition.process.nodes.forEach(m => {
      m.position = JSON.stringify(m.position)
    })
    definition.process.connections.forEach(m => {
      m.timing = JSON.stringify(m.timing)
      m.notice && m.notice.forEach(el => {
        el.ways = JSON.stringify(el.ways)
        el.targetNode = JSON.stringify(el.targetNode)
        el.targetUser = JSON.stringify(el.targetUser)
        el.targetComponent = JSON.stringify(el.targetComponent)
      })
    })
    if (definition.appSwitch) {
      definition.appIcon = definition.appIcon.includes('data:image') ? '' : definition.appIcon
    }
    definition.process.attribute.interactions.forEach(item => {
      if (item.triggerConnections) {
        item.triggerConnections = item.triggerConnections.join(',')
      }
    })
    definition.comment = this.getComment()
    let model = {
      definition,
      schema: formService.schema,
      component: formService.form
    }
    return axios.post('/process-api/processes', model)
  }

  getComment () {
    // processComponent  控件
    // processDefinition.process.nodes  节点
    // formValidates 操作校验
    // interactions 数据联动
    // 控件交互 在 processComponent properties 中
    if (!this.processVue.id) return ''
    let comment = ''
    let processComponent = JSON.parse(this.processVue.processValue.processComponent)
    // TODO 操作校验默认一组，删除之后会导致值从null变成了 [] 如果删除默认空数组 这里也需要修改
    if (!processComponent.formValidates) {
      processComponent.formValidates = []
    }
    if (JSON.stringify(this.processVue.processComponent) !== JSON.stringify(processComponent)) {
      if (JSON.stringify(processComponent.children) !== JSON.stringify(this.processVue.processComponent.children)) {
        comment += '更新控件、'
      } else {
        // 包含控件交互、节点交互、操作校验
        comment += '更新全局设置、'
      }
    }
    // 说明流程被修改过
    let processValue = JSON.parse(this.processVue.processValue.processDefinition)
    if (JSON.stringify(this.processVue.processDefinition) !== this.processVue.processValue.processDefinition) {
      if (JSON.stringify(this.processVue.processDefinition.process.nodes) !== JSON.stringify(processValue.process.nodes)) {
        comment += '更新节点、'
      } else {
        if (!comment.includes('全局设置')) {
          comment += '更新全局设置'
        }
      }
    }
    if (comment && comment.charAt(comment.length - 1) === '、') {
      comment = comment.slice(0, comment.length - 1)
    }
    return comment
  }

  reset () {
    // 清表单信息
    this.processDefinition.resetProcess()
  }

  // 给控件名字新增 拼音 和 缩写
  async getPinyinByHanzi (name) {
    let result = {}
    await axios({
      method: 'get',
      url: '/shared-api/pinyin/getPinyinByHanzi',
      disableInterceptors: true,
      params: {hanzi: name}
    }).then(res => {
      result = res.data
    }).catch(res => {
      result = {pinyinName: '', pinyinFirstChar: ''}
    })
    return result
  }
}



// WEBPACK FOOTER //
// ./src/store/process/processService.js